import { render } from "./TableColumnManagerModal.vue?vue&type=template&id=b85d521a&scoped=true"
import script from "./TableColumnManagerModal.vue?vue&type=script&lang=js"
export * from "./TableColumnManagerModal.vue?vue&type=script&lang=js"

import "./TableColumnManagerModal.vue?vue&type=style&index=0&id=b85d521a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85d521a"]])

export default __exports__